export default __webpack_public_path__ + "static/media/orange-ship.b0c26b24.png";